import { useEffect, useState } from "react"
import getConfig from "config"

export type RetryConfig = {
  maxAttempts?: number
  delayMs?: number
}

export type ElectronConfig = {
  url?: string
  device_location?: string
  device_name?: string
  retry?: RetryConfig
}

export type IUseElectronConfig = () => {
  config: ElectronConfig | null
}

export const useElectronConfig: IUseElectronConfig = () => {
  const [config, setConfig] = useState<ElectronConfig | null>(null)
  // To remember the latest callback .
  useEffect(() => {
    const electron = window.electron
    if (electron) {
      const initSetting = async () => {
        const setting = await window.electron.invoke<
          any,
          ElectronConfig | null
        >("getSettingsData")
        if (setting) {
          setConfig(setting)
          if (getConfig("env") === "development")
            console.log("Electron - Setting up React configuration:", setting)
        }
      }
      initSetting()
    }
  }, [])

  return { config }
}
